export default "__VITE_ASSET__5557d1a9__"